export const theme = {
  colors: {
    accent: {
      primary: '#D12430',
      secondary: '#0F0F15',
      rfe: '#ea6903',
    },
  },
  fonts: {
    base: '"Skolar Sans PE", sans-serif',
    headings: '"Skolar Sans PE", sans-serif',
  },
  ease: {
    in: 'cubic-bezier(.55,.06,.68,.19)',
    out: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
    inOut: 'cubic-bezier(.46,.03,.52,.96)',
  },
}
